export function IsRender({ children, rIf }: { children: JSX.Element, rIf: any } ){
    return rIf ? children : null;
}
